import styled from 'styled-components';
import DatePicker from 'antd-mobile/es/date-picker';

export const MobileDatePicker = styled(DatePicker)``;
